module.exports = __webpack_public_path__ + "static/img/client_upgraded_en.014d8f83.png";